const persistableItems: string[] = [
	// 'barista',
]

export { persistableItems }
